{
	"title": "Service indisponible (500)",
	"description": "Essayez d’actualiser cette page ou vérifiez votre connexion Internet. Si cette erreur persiste, veuillez la signaler comme un bug afin que nous puissions agir.",
	"primaryButtonTitle": "Actualiser la page",
	"secondaryButtonTitle": "Copier le journal d’erreur",
	"errorLogCopiedMessage": "Journal d'erreur copié",
	"traceparentLabel": "Traceparent"
}
